import React from 'react';
import { ListItemButton, ListItemAvatar, ListItemText, Avatar, Box } from '@mui/material';
import { MSN } from './msnTheme';
import { getAuthenticatedUploadUrl } from '../../api/client';

const STATUS_COLOR = MSN.statusBorder || {
  available: MSN.online,
  busy: MSN.busy,
  away: MSN.away,
  offline: MSN.offline
};

/**
 * Item de contato — hover corporativo (action.hover).
 */
export default function ContactItem({ contact, presenceStatus, onClick, selected = false }) {
  const status = presenceStatus || contact?.status || 'offline';

  return (
    <ListItemButton
      selected={selected}
      onClick={() => onClick(contact)}
      sx={{
        borderRadius: 1,
        mx: 1,
        py: 0.75,
        '&:hover': { bgcolor: 'action.hover' },
        '&.Mui-selected': { bgcolor: 'action.selected' },
        '&.Mui-selected:hover': { bgcolor: 'action.selected' },
        '&:focus-visible': { outline: '2px solid', outlineColor: 'primary.main', outlineOffset: 1 }
      }}
    >
      <ListItemAvatar sx={{ minWidth: 44 }}>
        <Box sx={{ position: 'relative' }}>
          <Box
            sx={{
              display: 'inline-block',
              borderRadius: 2,
              border: `2px solid ${STATUS_COLOR[status] || STATUS_COLOR.offline}`,
              p: 0.2,
              overflow: 'hidden'
            }}
          >
            <Avatar
              src={contact?.fotoPerfil ? getAuthenticatedUploadUrl(contact.fotoPerfil) : undefined}
              sx={{
                width: 40,
                height: 40,
                bgcolor: 'primary.main',
                color: '#fff',
                fontSize: 14
              }}
            >
              {!contact?.fotoPerfil && (contact?.nome || contact?.email || '?').charAt(0).toUpperCase()}
            </Avatar>
          </Box>
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              right: 0,
              width: 12,
              height: 12,
              borderRadius: '50%',
              bgcolor: STATUS_COLOR[status] || STATUS_COLOR.offline,
              border: '2px solid #fff'
            }}
            aria-hidden
          />
        </Box>
      </ListItemAvatar>
      <ListItemText
        primary={contact?.nome || contact?.email}
        secondary={contact?.cargo || contact?.setor || null}
        primaryTypographyProps={{ fontSize: 13, fontWeight: 500, color: 'text.primary' }}
        secondaryTypographyProps={{ fontSize: 11, color: 'text.secondary' }}
      />
    </ListItemButton>
  );
}
